export const agencyMatch = bool => ({
    type: 'AGENCY_MATCH',
    bool
})